<template>
  <v-app class="d-flex flex-column flex-root bg-white">
    <div class="login login-1 login-signin-on d-flex flex-row-fluid bg-white" id="kt_login">
      <div class="login-aside d-flex flex-row-auto bgi-size-cover bgi-no-repeat p-10 p-lg-15">
        <div class="d-flex flex-row-fluid flex-column justify-content-between">
          <router-link :to="{ name: 'root' }" class="flex-column-auto d-flex align-items-center">
            <img src="media/logo.png" style="height: 50px;" />
            <h3 class="font-size-h1 text-white ml-5">Добро пожаловать в СтройТакси!</h3>
          </router-link>

          <div class="flex-column-fluid d-flex flex-column justify-content-center">
            <p
              class="font-weight-lighter text-white opacity-80"
            >СтройТакси – служба заказа спецтехники №1 в России. В целом, это аналог привычных диспетчерских служб такси (Яндекс.Такси, Gett Taxi), но в сфере строительной и специальной техники. Заказ всех видов техники в «одном окне».</p>
            <p
              class="font-weight-lighter text-white opacity-80"
            >Постоянные дополнительные заказы на вашу технику. Комиссия за успешные заказы от 10%.</p>
            <p class="font-weight-lighter text-white opacity-80">
              Если вашего города нет в списке, вы можете
              <a href="https://stroitaxi.com/franshiza" target="_blank">открыть филиал по франшизе</a>
            </p>
            <p
              class="font-weight-lighter text-white opacity-80"
            >По всем вопросам: <a href="tel:88002229066">8 (800) 222-90-66</a> Звонок бесплатный по России</p>
          </div>

          <div class="d-none flex-column-auto d-lg-flex justify-content-between mt-15">
            <div class="opacity-70 font-weight-bold text-white">© 2020 СтройТакси</div>
            <div class="d-flex">
              <a href="https://stroitaxi.com/kontakty" class="text-white">Контакты</a>
            </div>
          </div>
        </div>
      </div>

      <div class="flex-row-fluid d-flex flex-column position-relative p-10 pb-20 bg-white">
        <router-view></router-view>
      </div>
    </div>
  </v-app>
</template>

<!-- Load login custom page styles -->
<style lang="scss">
@import "~vuetify/dist/vuetify.css";
@import "@/assets/sass/pages/users/login-1.scss";
</style>

<script>
export default {
  name: "auth",
  metaInfo: {
    title: "Авторизация"
  },
  methods: {}
};
</script>
